<template>
  <div class="box-div" :class="showType === 'verify' ? 'cur' : ''">
    <div class="login-title">{{siteTitle}}</div>

    <!-- 忘记密码 -->
    <div>
      <div style="height: 20px;"></div>
      <el-form ref="formBind" class="login-from" :model="bindData" :rules="bindCheck" validate>
        <el-form-item label="" prop="phone">
          <el-input v-model="bindData.phone" autofocus placeholder="手机号"></el-input>
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="15">
            <el-form-item label="" prop="verifyCode">
              <el-input v-model="bindData.verifyCode" autofocus placeholder="短信验证码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-button v-if="!codeSend && !codeIsSend" type="info" style="padding: 12px 0; width: 100%;">获取验证码</el-button>
            <el-button v-else-if="codeSend && !codeIsSend" type="primary" style="padding: 12px 0; width: 100%;" @click="showCode">获取验证码</el-button>
            <el-button v-else-if="codeIsSend" type="info" disabled style="padding: 12px 0; width: 100%;">{{count}}秒后重新发送</el-button>
          </el-col>
        </el-row>
        <el-form-item label="" prop="companyCnName" v-if="siteTitle != '找回密码'">
          <el-input v-model="bindData.companyCnName" placeholder="公司名称"></el-input>
        </el-form-item>
        <el-form-item label="" prop="companyAddress" v-if="siteTitle != '找回密码'">
          <el-input v-model="bindData.companyAddress" placeholder="公司地址"></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <el-input v-model="bindData.password" placeholder="密码" show-password autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="" prop="checkPass">
          <el-input v-model="bindData.checkPass" placeholder="确认密码" show-password autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="siteTitle === '找回密码'" type="primary" :loading="loading" @click="submitData('formBind')" style="width: 100%; margin-top: 20px;">
            <span v-if="!loading">提 交</span>
            <span v-else>请稍后...</span>
          </el-button>
          <el-button v-else :disabled="!checked" type="primary" :loading="loading" @click="submitData('formBind')" style="width: 100%; margin-top: 20px;">
            <span v-if="!loading">提 交</span>
            <span v-else>请稍后...</span>
          </el-button>
        </el-form-item>
        <div style="margin-top: 20px;">
          <span v-if="loginInfo">
            <el-checkbox v-model="checked" style="font-weight: 400;"><span style="color: #333; padding-right: 10px;">我已阅读并同意</span><span class="blueText" @click="visible = true">服务条款</span></el-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <span class="blueText" @click="back">返回登录</span>
        </div>
      </el-form>
    </div>

    <!-- 输入图形验证码 -->
    <div class="showModal" v-if="showVerCode">
      <div class="modal-body">
        <div class="demo-modal-header">
          <div class="drawerHead">
            <span class="inner">输入验证码</span>
            <div class="demo-top-close">
              <Icon type="ios-close" size="34" @click="closeVerModal" />
            </div>
          </div>
        </div>
        <div class="verCon">
          <img id="verImg" :src="imgVer.codeImg" width="130px" height="48px" />
          <div style="display: flex; flex-direction: row; width: 300px; margin: 0 auto;">
            <div style="width: 250px;">
              <el-input :value="imgVer.verifyCode" @input="changeCode" @change="enterCode" placeholder="输入验证码"></el-input>
            </div>
            <el-button style="margin-left: 6px;" @click="showCode"><i class="el-icon-refresh"></i></el-button>
          </div>
          <el-button type="primary" :loading="submiting" style="height: 42px; width: 300px; margin-top: 16px;" @click="enterCode">
            <span v-if="!submiting">提交验证</span>
            <span v-else>请稍后...</span>
          </el-button>
          <div style="height: 30px;">
            <div style="line-height: 30px; color: red;">{{errorCode}}</div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <el-dialog width="96%" :visible.sync="visible" center fullscreen :modal="false">
        <div class="demo-modal-body">
          <div class="tk-h2">服务条款</div>
          <div class="tk-title">协议构成及须知</div>
          <div class="tk-text">
            <div>1、</div>
            <div style="flex: 1;">本协议是“E航无忧”的注册用户（包括使用“E航无忧”平台的个人和所代表的企业）与“E航无忧”运营企业（杭州未斯科技有限公司）之间的法律契约，注册“E航无忧”即代表接受本协议的约束，并自注册成功之时即成为本协议的一方（即“E航无忧”用户）并自发出协议之时即受协议条款的约束。</div>
          </div>
          <div class="tk-text">
            <div>2、</div>
            <div style="flex: 1;">本协议受中华人民共和国法律管辖，签约地为上海。下文中的“E航无忧”指其运营企业杭州未斯科技有限公司，是本协议的契约方之一。下文中的“用户”指“E航无忧”注册用户，是本协议的契约方之另一方。</div>
          </div>
          <div class="tk-text">
            <div>3、</div>
            <div style="flex: 1;">用户欲访问和使用“E航无忧”，必须事先认真阅读本协议中的各条款，包括免除或者限制“E航无忧”责任的免责条款及对用户的权利限制。请审阅并选择接受或不接受本协议。如不同意本协议条款及/或随时对其的修改，请不使用或主动取消“E航无忧”提供的服务。对“E航无忧”的使用行为将被视为对本协议条款的完全接受，包括接受“E航无忧”对条款所做的任何修改。</div>
          </div>

          <div class="tk-title">用户使用规则</div>
          <div class="tk-text">
            <div>1、</div>
            <div style="flex: 1;">“E航无忧”服务仅限于为用户提供正常和合法业务工具，用户如果使用“E航无忧”产品从事以下行为，即导致根本性违约，“E航无忧”有权随时停止服务、解除本协议，并追讨因此带来的损失：</div>
          </div>
          <div class="tk-txt">
            <div>1）</div>
            <div style="flex: 1;">有明确证据表明用户使用“E航无忧”用于违反法律的业务。用户发送了任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽等内容的信息。</div>
          </div>
          <div class="tk-txt">
            <div>2）</div>
            <div style="flex: 1;">对“E航无忧”产品进行了任何形式的对其他第三方的再授权使用，销售或转让。</div>
          </div>
          <div class="tk-txt">
            <div>3）</div>
            <div style="flex: 1;">提供的公司信息或个人资料不真实，或有可能对“E航无忧”其他用户构成误导甚至欺诈。</div>
          </div>
          <div class="tk-txt">
            <div>4）</div>
            <div style="flex: 1;">滥用“E航无忧”产品的通信功能发送垃圾邮件和短信。</div>
          </div>
          <div class="tk-txt">
            <div>5）</div>
            <div style="flex: 1;">对 “E航无忧” 的连续服务和商誉构成损害的其他行为，包括对“E航无忧”服务器的攻击。</div>
          </div>
          <div class="tk-txt">
            <div>6）</div>
            <div style="flex: 1;">其他“E航无忧”认为是不符合整体服务需求的特殊情形。</div>
          </div>
          <div class="tk-text">
            <div>2、</div>
            <div style="flex: 1;">“E航无忧”使用用户所拥有的互联网域名所对应的电子邮件地址作为用户权证的唯一识别信息。当用户不再拥有在“E航无忧”所登记的域名时，“E航无忧”有权随时删除该用户的所有数据。</div>
          </div>
          <div class="tk-text">
            <div>3、</div>
            <div style="flex: 1;">用户必须自行配备上网和使用电信增值业务所需的设备，自行负担上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，请与您的电信增值服务提供商确认相关的费用问题。</div>
          </div>

          <div class="tk-title">知识产权</div>
          <div class="tk-text">
            <div>1、</div>
            <div style="flex: 1;">用户完全拥有在使用“E航无忧”平台时创建的数据和资料（包括但不限于：货物资料、价格数据、客户资料、联系人等信息）的所有权，并有权进行任何形式的处置，包括从“E航无忧”平台中复制、导出和删除。未经授权，“E航无忧”不得使用用户的数据。</div>
          </div>
          <div class="tk-text">
            <div>2、</div>
            <div style="flex: 1;">“E航无忧”完全拥有“E航无忧”平台的全部知识产权，用户签署本协议后并未拥有“E航无忧”平台的所有权。“E航无忧”的公司名称、标志、LOGO、产品名字，以及“E航无忧”平台的应用程序、源代码、界面设计、应用程序编程接口（API）等所关联的知识产权都已经属于杭州未斯科技有限公司，未经授权不能使用。</div>
          </div>
          <div class="tk-text">
            <div>3、</div>
            <div style="flex: 1;">用户不得将涉及“E航无忧”拥有知识产权的相关内容用于本协议范围以外的任何商业目的或泄露给第三方。用户不得出售、转售或复制“E航无忧”产品，亦不可基于商业目的模仿“E航无忧”的产品和服务。用户不可复制和模仿“E航无忧”的设计理念、界面、功能和文字及图形说明。未经“E航无忧”许可，用户不得基于此协议所约定的服务对“E航无忧”平台进行修改或制造、衍生其它产品。</div>
          </div>

          <div class="tk-title">数据安全及保密</div>
          <div class="tk-text">
            <div>1、</div>
            <div style="flex: 1;">数据备份：在近实时备份之上，“E航无忧”保证每天数据完整备份至少一次，增量备份至少三次。月备份保留一年， 日备份保留一周，增量备份保留一天。“E航无忧”每天都对用户储存在“E航无忧”服务器上的数据信息进行异地备份，做好冗灾预防机制，以确保在系统发生问题后，可以快速恢复系统正常运行。</div>
          </div>
          <div class="tk-text">
            <div>2、</div>
            <div style="flex: 1;">用户有义务维护自己在“E航无忧”平台中的账户信息的完整性、密码的保密性。因用户维护或保密不善致使相关信息泄露，或由于第三方盗用用户帐号和密码进行各种操作而造成的损失，由用户自行负责。用户不得向他人提供“E航无忧”在线平台的全部或部分服务，也不得容许他人通过自己的账户使用“E航无忧”平台。</div>
          </div>
          <div class="tk-text">
            <div>3、</div>
            <div style="flex: 1;">“E航无忧”的客服人员不接受用户的口头请求对其密码进行重置。“E航无忧”对用户初始化后的密码不可知。对所有用户输入的信息和上传的文件， “E航无忧”员工不能对其进行其他任何侵犯隐私的操作。</div>
          </div>
          <div class="tk-text">
            <div>4、</div>
            <div style="flex: 1;">用户对其输入数据的准确性、可靠性、合法性、适用性等自行负责。用户不可破坏“E航无忧”的安全或授权措施，不可翻阅或存取非自己所有的数据。</div>
          </div>
          <div class="tk-text">
            <div>5、</div>
            <div style="flex: 1;">除应政府或司法机关调查或法律要求外，“E航无忧”直接口头或书面向第三方提供涉及用户在使用“E航无忧”平台过程中保存在“E航无忧”服务器上的数据的行为属于泄密行为，所造成对用户的直接损失，并经证实，用户有权通过法律途径要求“E航无忧”按协议相应条款赔偿。</div>
          </div>
          <div class="tk-text">
            <div>6、</div>
            <div style="flex: 1;">本条款中的保密义务、权利和责任不适用于如下信息：(1)非由于“E航无忧”不正当的原因已经为公众所知的；(2)由“E航无忧”以外其他渠道被他人获知的信息，这些渠道并不受保密义务的限制；(3)经用户授权发布的信息; (4)由于法律、法院或其他国家有权机关的要求而披露的信息。</div>
          </div>
          <div class="tk-text">
            <div>7、</div>
            <div style="flex: 1;">“E航无忧”保留使用汇总统计信息的权利，但这些信息是匿名，且不针对特定用户的。</div>
          </div>
          <div class="tk-text">
            <div>8、</div>
            <div style="flex: 1;">“E航无忧”保留面向基础版用户刊载广告的权利，这些广告刊载过程中将可能使用必要的定向技术来提高广告相关度，但“E航无忧”不会将用户的个人信息透露给广告商，而只会在匿名的基础上通过自动化匹配技术实现广告优化刊载。</div>
          </div>

          <div class="tk-title">服务水平及赔偿</div>
          <div class="tk-text">
            <div>1、</div>
            <div style="flex: 1;">“E航无忧”将尽最大努力保障平台的连续可靠运行，“E航无忧”进行任何计划的停机升级或维护，应提前一周通知用户。 此项停机时间不计算在正常运行时间可用性百分比之内。用户如果对升级、维护停机时间有不同意见，需在收到通知的次日内提出要求并与“E航无忧”协商。正常运行时间可用性百分比是指每个自然月停机时间（分钟）占全月工作时间（分钟）的百分比。计算公式为：1 - [ （当月异常停机时间总和）/（60×24×当月天数 – 计划的停机维护时间）]</div>
          </div>
          <div class="tk-text">
            <div>2、</div>
            <div style="flex: 1;">“E航无忧”将尽最大努力保障用户数据的安全备份，“E航无忧”承诺在有任何用户数据因服务器存储设备损坏时以最快的速度从最近的备份中恢复数据，但无法承诺100%的数据恢复，对因数据丢失带来的其他连带或间接损失不承担任何责任。</div>
          </div>
          <div class="tk-text">
            <div>3、</div>
            <div style="flex: 1;">在发生需要从备份文件中恢复数据的情形时，“E航无忧”通常需要4小时，最长48小时完成，在此时间范围内的数据恢复视作服务是连续的。</div>
          </div>

          <div class="tk-title">不可抗力及免责条款</div>
          <div class="tk-text">
            <div>1、</div>
            <div style="flex: 1;">因一切不由“E航无忧”可控因素引起的服务中断和长时间终止不属于“E航无忧”违约，不承担赔偿责任。不可控因素包括但不限于：</div>
          </div>
          <div class="tk-txt">
            <div>1）</div>
            <div style="flex: 1;">用户的方客户终端硬件及网络，互联网络，机房供电系统故障；</div>
          </div>
          <div class="tk-txt">
            <div>2）</div>
            <div style="flex: 1;">不可抗力：</div>
          </div>
          <div class="tk-desc">地震、台风、洪水等自然灾害；</div>
          <div class="tk-desc">战争、罢工、停电、政府行为等；</div>
          <div class="tk-desc">政府电力部门或电信部门的行为；</div>
          <div class="tk-desc">电信线路被人为破坏或骨干网线路、设备因调试、扩容所引起的中断；</div>
          <div class="tk-desc">INTERNET公网阻塞或其他通路（如访问目的地的服务器响应速度）问题；</div>
          <div class="tk-desc">外部人为破坏因素引起的，超过安全设备的承载能力。</div>
          <div class="tk-txt">
            <div>3）</div>
            <div style="flex: 1;">其它不可预见、不可避免、不可克服和不可控制的不可抗力。</div>
          </div>
          <div class="tk-desc">遭受不可抗力的一方应采取一切必要措施减少损失，并在事件消除后协商恢复本合同的履行。</div>
          <div class="tk-text">
            <div>2、</div>
            <div style="flex: 1;">“E航无忧”不保证网址所载公开信息、软件演示和免费软件服务内容的准确性、可靠性或完整性，并明确地否认就该等信息和软件功能的错误或遗漏承担责任；并不对信息和免费软件做出任何种类的保证，包括（但不限于）有关没有侵犯第三方权利、所有权、适销性、质量令人满意、适合特定的用途和没有计算机病毒的保证。</div>
          </div>
          <div class="tk-text">
            <div>3、</div>
            <div style="flex: 1;">“E航无忧”对任何损害概不负责，无论这些损害是否由于使用、不能使用本平台的结果或由连到本平台的任何Web网站或者任何这类网站中包含的信息所引起（包括但不限于由损失的利润、损失的数据或业务中断而造成的损害），也不管它们是否有保证、合同、侵权行为或任何其它法律根据以及事前已得到这类损害可能发生的消息。如果用户由于使用本站的免费信息和免费软件版本导致需要对设备或数据进行维护、修理或纠正，用户须承担由此而造成的所有费用。</div>
          </div>
          <div class="tk-text">
            <div>4、</div>
            <div style="flex: 1;">在任何情况下，“E航无忧”对于与使用或未能使用本平台或任何链接的网站免费的内容、资料、软件功能有关任何直接的、间接的、特殊的、连带的或其它损失（包括但不限于任何利润损失、业务中断以及您的信息处理系统中的信息或程序或其它数据的丢失）不向任何机构承担责任。</div>
          </div>
          <div class="tk-text">
            <div>5、</div>
            <div style="flex: 1;">“E航无忧”平台、论坛、博客中的所有言论并不代表“E航无忧”的观点。这里所指的言论包括新闻及动态但不仅限于此。如果上面的言论对用户造成伤害，“E航无忧”将协助您及有关部门依据相关法律法规清除相关内容并查找IP记录，但“E航无忧”不承担任何责任。</div>
          </div>

          <div class="tk-title">条款修订</div>
          <div class="tk-text">
            <div>1、</div>
            <div style="flex: 1;">“E航无忧”有权随时对本协议的条款进行修订，并在修订生效日前三个工作日更新在“E航无忧”网站。</div>
          </div>
          <div class="tk-text">
            <div>2、</div>
            <div style="flex: 1;">修订的条款始终公开在“E航无忧”平台条款页面</div>
          </div>

          <div class="tk-title">争议解决</div>
          <div class="tk-text">如果就本协议的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。如果在一方向其他方送达要求开始协商的书面通知后六十天内未能通过协商解决争议，那么任何一方均可将争议提交至中国国际经济贸易仲裁委员会上海分会，按照其届时有效的规则进行仲裁。仲裁裁决是终局的，对各方均有约束力，不可上诉。仲裁费用由败诉方承担，除非仲裁裁决另有规定。当任何争议发生时以及在对任何争议进行仲裁时，除争议事项外，各方应继续行使各自在本协议项下的其他权利，履行各自在本协议项下的其他义务。</div>

        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="medium" style="width: 100px;" @click="visible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax";
const rulePhone = /^\d{11}$/ // 手机号码校验规则

export default {
  name: "login",
  props: {
    siteTitle: String,
    showType: String,
    qrcode: Object,
    loginInfo: Object,
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.bindData.checkPass !== '') {
          this.$refs.formBind.validateField('checkPass');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.bindData.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    // 手机号验证
    const phoneValidate = async(rule, value, callback) => {
      if (value.length < 1) {
        this.codeSend = false;
        return callback(new Error('手机号码不能为空'));
      } else if (!rulePhone.test(value)) {
        this.codeSend = false;
        return callback(new Error('手机号码格式不正确'));
      } else{
        this.codeSend = true;
        callback();
      }
    };
    const companyCnNameValidate = (rule, value, callback) => {
      if (value.length < 1){
        return callback(new Error('公司名称不能为空'));
      } else if (value.length > 255){
        return callback(new Error('公司名称长度不能大于255位'));
      } else{
        callback();
      }
    };
    const addressValidate = (rule, value, callback) => {
      if (value.length < 1){
        return callback(new Error('公司地址不能为空'));
      } else if (value.length > 255){
        return callback(new Error('公司地址长度不能大于255位'));
      } else{
        callback();
      }
    };
    return {
      loading: false,
      submiting: false,
      visible: false,
      checked: false,

      timer: null,
      count: null,
      codeSend: false,
      codeIsSend: false,
      sendSubmit: true,
      // 
      bindData: {
        phone: '',
        verifyCode: '',
        password: '',
        checkPass: '',
        companyCnName:'',
        companyAddress:'',
      },
      bindCheck: {
        phone: [{ required: true, validator: phoneValidate, trigger: "change" }],
        verifyCode: [{ required: true, message: '请输入短信验证码', trigger: 'change' }],
        password: [{ validator: validatePass, trigger: 'change' }],
        checkPass: [{ validator: validatePass2, trigger: 'change' }],
        companyCnName: [{ validator: companyCnNameValidate, trigger: 'change' }],
        companyAddress: [{ validator: addressValidate, trigger: 'change' }],
      },

      // 图形验证码
      showVerCode: false,
      errorCode: '',
      imgVer: {
        codeImg: '',
        key: '',
        verifyCode: '',
      },
    };
  },
  mounted() {
    // console.log(this.loginInfo);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // 倒计时
    timeFun() {
      this.count = 60;
      this.timer = setInterval(() => {
        if(this.count === 1) {
          this.codeIsSend = false;
          clearInterval(this.timer);
        } else {
          this.count--;
        }
      }, 1000);
    },

    // 显示验证码
    showCode() {
      if(this.bindData.phone === ''){
        this.$message({
          message: '请输入手机号',
          type: 'error'
        })
        return;
      }
      httpAjax({
        url: '/services/verify/captcha',
        method: "get",
      }).then((response) => {
        if (response.success) {
					this.imgVer.codeImg = response.data.image;
          this.imgVer.key = response.data.key;
          this.showVerCode = true;
				} else {
					this.$message({
            message: response.msg,
            type: 'error'
          })
				}
      });
    },

    // 关闭验证码
    closeVerModal() {
      this.showVerCode = false;
      this.imgVer.verifyCode = '';
      this.errorCode = '';
    },

    // 输入验证码
    changeCode(value) { 
      this.imgVer.verifyCode = value;
    },

    // 提交验证码
    enterCode() {
      if (this.imgVer.verifyCode === '') {
        this.errorCode = '请输入验证码';
        return;
      }
      this.submiting = true;
      httpAjax({
        url: '/services/verify/send/verifySms',
        method: "get",
        data: {
          key: this.imgVer.key,
          phoneNumber: this.bindData.phone,
          verifyCode: this.imgVer.verifyCode,
          type: this.loginInfo ? 'register' : 'fp'
        }
      }).then((response) => {
        if (response.success) {
          this.closeVerModal();
          this.codeIsSend = true;
          this.count = 60;
          this.timeFun();
				} else {
          this.errorCode = response.msg;
				}
        this.submiting = false;
      });
    },

    // 微信绑定手机
    submitData(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = {
            phone: this.bindData.phone,
            verifyCode: this.bindData.verifyCode,
          };
          if(this.siteTitle === '找回密码') {
            params.password = this.bindData.password;
            params.confirmPassword = this.bindData.checkPass
          } else {
            params.uid = this.qrcode.uid;
            params.openId = this.loginInfo.openId;
            params.password = this.bindData.password;
            params.confirmPassword = this.bindData.checkPass
            params.companyCnName = this.bindData.companyCnName;
            params.companyAddress = this.bindData.companyAddress;
          }
          httpAjax({
            url: this.loginInfo ? '/services/wx/register' : `/services/user/forgotPassword`,
            method: 'post',
            data: params
          }).then((response) => {
            if (response.success) {
              this.$message({
                message: this.loginInfo ? '用户注册成功' : '密码修改成功，请重新登录',
                type: 'success'
              });
              if (this.loginInfo) {
                this.registerOk(false);
              } else {
                this.back();
              }
            } else {
              this.$message({
                message: response.msg,
                type: 'error'
              })
            }
            this.loading = false;
          });
        }
      });
    },

    // 注册成功
    registerOk() {
      // this.$parent.success();
      this.$emit('success')
    },

    // 返回登录
    back() {
      this.$emit('backLogin')
      // this.$parent.backLogin();
    },
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less">
.login-title {
  font-size: 26px;
  padding: 50px 0 20px;
  text-align: center;
}

.box-div {
  opacity: 0;
  transition: 0.5s;

  &.cur {
    opacity: 1;
  }
}
.showModal {
  position: absolute;
  top: 0;
  right: 0;
  width: 460px;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  .modal-body {
    width: 90%;
    text-align: center;
    background: #fff;
    margin: 130px auto 0;
  }
}
</style>